module.exports = __webpack_public_path__ + "img/rock.80b610c3.svg";